import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex flex-col gap-[20px]',
    itemsGroup:
      'relative z-0 grid grid-cols-1 gap-6 md:grid-cols-2 md:gap-[24px_40px]',
    collapseButton: 'heading-s-bold h-fit w-fit p-0',
    collapseArrow: '-mb-[2px] ml-2 h-6 w-6 -rotate-90'
  },
  variants: {
    collapse: {
      true: {
        collapseArrow: 'rotate-90'
      }
    }
  }
});
